import { RefObject, useCallback, useEffect } from "react";

interface UseAutoResizeTextareaOptions {
  maxLines?: number;
  enabled?: boolean;
}

export default function useAutoResizeTextarea(
  ref: RefObject<HTMLTextAreaElement>,
  value: string,
  options?: UseAutoResizeTextareaOptions
) {
  const maxLines = options?.maxLines ?? 7;
  const enabled = options?.enabled ?? true;

  const resize = useCallback(() => {
    const el = ref.current;
    if (!el) return;

    if (!enabled) {
      el.style.height = "";
      el.style.overflowY = "";
      return;
    }

    const styles = window.getComputedStyle(el);
    const lineHeight = parseFloat(styles.lineHeight || "20");
    const paddingTop = parseFloat(styles.paddingTop || "0");
    const paddingBottom = parseFloat(styles.paddingBottom || "0");
    const maxHeight = lineHeight * maxLines + paddingTop + paddingBottom;

    el.style.height = "0px";
    const nextHeight = Math.min(el.scrollHeight, maxHeight);
    el.style.height = `${nextHeight}px`;
    el.style.overflowY = el.scrollHeight > maxHeight ? "auto" : "hidden";
  }, [ref, enabled, maxLines]);

  useEffect(() => {
    resize();
  }, [resize, value, enabled]);

  return resize;
}
